const swiperSolution = new Swiper('.solution-slider__contents', {
  loop: true,
  slidesPerView: 1.52,
  spaceBetween: 12,
  pagination: {
    el: '.solution-pagination',
    clickable: true,
  },
  navigation: {
    enabled: false,
  },
  breakpoints: {
    580: {
      slidesPerView: 2,
      loop: false,
    },
    980: {
      slidesPerView: 3,
      spaceBetween: 32,
      loop: false,
    }
  }
});
